<template>
  <div v-show="chatBotStore.isChatOpen" class="chat-history chat-wrapper">
    <div class="chat-header">
      <h3>Chat History</h3>
      <clear-history-btn />
    </div>

    <chat-history />

    <chat-input />
  </div>
  <button v-if="!chatBotStore.isChatOpen" class="chat-toggle-btn" @click="chatBotStore.toggleChat()">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
    <span>Open Chat</span>
  </button>
</template>

<script setup lang="ts">
import ChatHistory from "./chatHistory.vue";
import ChatInput from "./chatInput.vue";
import ClearHistoryBtn from "./clearHistoryBtn.vue";
import { useChatBotStore } from "../stores/chatBotStore";

const chatBotStore = useChatBotStore();
</script>

<style lang="css" scoped>
@import "../styles/chatBot.css";
</style>
